import { Col, Row } from "react-bootstrap";
import LabelController from "../../../atoms/Label/LabelController";
import AddressAutoCompleteController from "../../../atoms/InputController/LabelInside/Adress-Auto-Complete-Controller/AddressAutoCompleteController";

const AddressSection = ({ ...props }) => {
  const { address1, address2 } = props.newLeadContent;
  const { errors, inputValue, touched } = props;

  return (
    <div className="box-container">
      <Row>
        <LabelController label={address1.label} />
        <Col sm={6}>
          <AddressAutoCompleteController
            errors={errors}
            touched={touched}
            value={inputValue[address1.name]}
            handleSetAddressValuesByGoogleAPI={
              props.handleSetAddressValuesByGoogleAPI
            }
            onChange={props.onChange}
            label={address1.inputLabel}
            name={address1.name}
            placeholder={address1.name}
            type={address1.type}
          />
        </Col>
        <Col sm={6}>
          <AddressAutoCompleteController
            errors={errors}
            touched={touched}
            value={inputValue[address2.name]}
            handleSetAddressValuesByGoogleAPI={
              props.handleSetAddressValuesByGoogleAPI
            }
            onChange={props.onChange}
            label={address2.inputLabel}
            name={address2.name}
            placeholder={address2.name}
            type={address2.type}
          />
        </Col>
        <Col sm={6}></Col>
      </Row>
    </div>
  );
};

export default AddressSection;
